import React, { useEffect, useMemo, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

const MODES = ["", "stocks", "crypto", "oanda", "sports", "options", "swing", "catalyst"];
const RISKS = ["", "LOW", "MODERATE", "HIGH", "EXTREME"];
const FRESH = ["", "live", "public", "simulated"];

export default function AdminOracleFeed() {
  const [mode, setMode] = useState("");
  const [risk, setRisk] = useState("");
  const [hr, setHr] = useState("");
  const [df, setDf] = useState("");
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const params = useMemo(() => {
    const p = { limit: 50 };
    if (mode) p.mode = mode;
    if (risk) p.risk_level = risk;
    if (hr) p.human_review = hr === "yes";
    if (df) p.data_freshness = df;
    if (q) p.q = q;
    return p;
  }, [mode, risk, hr, df, q]);

  const load = async () => {
    setLoading(true);
    try { const { data } = await adminApi.oracleFeed(params); setRows(data?.feed || []); }
    finally { setLoading(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [mode, risk, hr, df]);

  return (
    <div className="admin-page" data-testid="admin-oracle-feed">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Live ORACLE Feed</h2>
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load}>↻ Refresh</button>
      </div>
      <div className="admin-filters">
        <select value={mode} onChange={(e)=>setMode(e.target.value)}>{MODES.map(m=><option key={m} value={m}>{m||"All modes"}</option>)}</select>
        <select value={risk} onChange={(e)=>setRisk(e.target.value)}>{RISKS.map(r=><option key={r} value={r}>{r||"Any risk"}</option>)}</select>
        <select value={df} onChange={(e)=>setDf(e.target.value)}>{FRESH.map(f=><option key={f} value={f}>{f? f.toUpperCase():"Any freshness"}</option>)}</select>
        <select value={hr} onChange={(e)=>setHr(e.target.value)}>
          <option value="">HITL: any</option><option value="yes">HITL required</option><option value="no">HITL not required</option>
        </select>
        <input type="text" placeholder="Search query…" value={q} onChange={(e)=>setQ(e.target.value)} onKeyDown={(e)=>e.key==="Enter" && load()} />
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={loading}>{loading?"…":"Apply"}</button>
      </div>
      <table className="admin-table">
        <thead><tr><th>Time</th><th>Mode</th><th>Verdict</th><th>Conf</th><th>Risk</th><th>Data</th><th>HITL</th><th>Query</th></tr></thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={i}>
              <td>{r.updated_at && new Date(r.updated_at).toLocaleString()}</td>
              <td><span className="rc-pill">{r.mode?.toUpperCase()}</span></td>
              <td><b>{r.verdict||"—"}</b></td>
              <td>{r.confidence_score ?? 0}/10</td>
              <td>{r.risk_level||"—"}</td>
              <td>{(r.data_freshness||"public").toUpperCase()}</td>
              <td>{r.human_review_required?"YES":"NO"}</td>
              <td className="admin-table__truncate" title={r.query}>{r.query}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="oracle-empty" style={{padding:14}}>No feed data yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
